import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./titledGroup.html";
class TitledGroup extends LightningElement {
  constructor(...args) {
    super(...args);
    // @ts-expect-error * Automated Type Error Fix
    this.tooltip = null;
    this.title = '';
    // Type-style token for the group title. Defaults to body-3.
    this.titleTypeStyle = 'body-3';
    this.titleRole = null;
    this.titleAriaLevel = null;
    this.tooltipAriaLabel = '';
    this.badges = [];
    // Optional override for the tooltip popover's orientation. Left null so the
    // inner wds-popover-tooltip keeps its own default (BOTTOM/RIGHT) for the
    // other consumers; provider details passes CENTER to align the popover and
    // arrow under the bare info icon.
    this.tooltipOrientation = null;
    this.flipIfOverflowsViewport = false;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(TitledGroup, {
  publicProps: {
    tooltip: {
      config: 0
    },
    title: {
      config: 0
    },
    titleTypeStyle: {
      config: 0
    },
    titleRole: {
      config: 0
    },
    titleAriaLevel: {
      config: 0
    },
    tooltipAriaLabel: {
      config: 0
    },
    badges: {
      config: 0
    },
    tooltipOrientation: {
      config: 0
    },
    flipIfOverflowsViewport: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(TitledGroup, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;